import { Link } from "react-router-dom"
import logo from "../assests/form_guru_logo.png"

export default function Footer() {
  return (
    <footer className="flex justify-center items-center py-8 px-5 border-t border-[var(--color-border)]">
      <div className="max-w-[1280px] w-full flex flex-col gap-5">
        {/* Top: brand + nav links */}
        <div className="flex items-center justify-between flex-wrap md:gap-6 gap-4">
          <Link to="/" className="flex items-center md:gap-3 gap-2">
            <img
              src={logo}
              alt="Form Guru"
              className="xl:h-20 md:h-16 h-12 w-auto"
            />
            <span className="brand-wordmark xl:text-[28px] md:text-2xl text-base text-[var(--color-text)]">
              FORM<span className="text-[var(--color-primary)]"> GURU</span>
            </span>
          </Link>

          <nav className="flex flex-wrap xl:gap-6 gap-4 xl:text-base md:text-sm text-xs font-semibold uppercase tracking-[0.06em]">
            <Link to="/privacy" className="text-[var(--color-text-muted)]">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-[var(--color-text-muted)]">
              Terms of Service
            </Link>
            <Link to="/help" className="text-[var(--color-text-muted)]">
              Help Center
            </Link>
          </nav>
        </div>

        {/* Bottom: copyright */}
        <div className="flex justify-between flex-wrap border-t border-[var(--color-border)] pt-4 gap-3">
          <p className="xl:text-sm text-xs text-[var(--color-text-light)] m-0">
            &copy; {new Date().getFullYear()} The FormGuru Analytics. All rights reserved.
          </p>
          <p className="xl:text-sm text-xs text-[var(--color-text-light)] m-0">
            Predictions are for informational purposes only.
          </p>
        </div>
      </div>
    </footer>
  );
}
